import { pdkAxios } from '@/lib/pdk-axios';
import { createFileRoute, useRouterState } from '@tanstack/react-router';
import axios from 'axios';
import { useEffect } from 'react';

const SLACK_ACCESS_TOKEN_URL = 'https://slack.com/api/oauth.v2.access';

export const Route = createFileRoute('/api/auth/callback/slack/')({
  component: SlackCallbackPage,
});

function SlackCallbackPage() {
  const { code, state } = useRouterState().location.search;
  useEffect(() => {
    const handleOAuthCallback = async () => {
      if (!code || !state) {
        console.error('Slack OAuth callback failed', { code, state });
        return;
      }

      const decodedState = JSON.parse(atob(state));
      const { redirect_uri } = decodedState;

      const SLACK_CLIENT_ID = import.meta.env.VITE_PADDOCK_SLACK_CLIENT_ID;
      // todo: NEED TO HANDLE THIS LOL
      const SLACK_CLIENT_SECRET = 'feca49f97fbf9a45090d82293662dd2b';

      // Exchange authorization code for access token
      const result = await axios({
        method: 'post',
        url: SLACK_ACCESS_TOKEN_URL,
        data: {
          code,
          client_id: SLACK_CLIENT_ID,
          client_secret: SLACK_CLIENT_SECRET,
          grant_type: 'authorization_code',
          redirect_uri,
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      // Get the access token from the response
      const data = result.data;
      try {
        await pdkAxios.post('/connect/slack', {
          access_token: data.access_token,
          user_id: data.authed_user.id,
        });
        window.close();
        // Close the window on success or failure
      } catch (err) {
        console.error('Slack OAuth callback failed', err);
        window.close();
      }
    };

    handleOAuthCallback();
  }, []);

  return <div>Connecting to Slack...</div>;
}
